<template>
  <div class="course-detail">
    <el-card v-loading="loading">
      <!-- 课程头部 -->
      <div class="course-header">
        <el-row :gutter="30">
          <el-col :xs="24" :md="12">
            <div class="course-cover">
              <el-image
                :src="course.course_imgs || '/static/images/default-course.png'"
                fit="cover"
              >
                <template #error>
                  <div class="image-slot">
                    <el-icon><Picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </el-col>
          
          <el-col :xs="24" :md="12">
            <div class="course-info">
              <h1 class="course-title">{{ course.course_name }}</h1>
              
              <div class="course-meta">
                <el-tag v-if="course.category" type="primary">{{ course.category.name }}</el-tag>
                <span class="meta-item">
                  <el-icon><Clock /></el-icon>
                  {{ course.class_hour }}课时
                </span>
              </div>
              
              <div class="course-desc">
                {{ course.course_desc }}
              </div>
              
              <div class="course-price">
                <span class="price-label">价格：</span>
                <span class="price-value">¥{{ course.price }}</span>
              </div>
              
              <div class="course-actions">
                <el-button
                  type="primary"
                  size="large"
                  @click="handleBuyNow"
                >
                  立即购买
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 课程详情 -->
      <el-tabs v-model="activeTab" class="course-tabs">
        <el-tab-pane label="课程介绍" name="intro">
          <div class="course-intro">
            <p>{{ course.course_desc }}</p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import courseApi from '@/api/course'
import { 
  Picture, 
  Clock
} from '@element-plus/icons-vue'
import { setDocumentTitle } from '@/utils/title'
import { DEFAULT_SHARE_IMAGE, setWechatShare } from '@/utils/wechatShare'

export default {
  name: 'CourseDetail',
  
  components: {
    Picture,
    Clock
  },
  
  data() {
    return {
      course: {},
      loading: false,
      activeTab: 'intro'
    }
  },
  
  mounted() {
    this.loadCourseDetail()
  },
  
  methods: {
    /**
     * 加载课程详情
     */
    async loadCourseDetail() {
      const courseId = this.$route.params.id
      
      if (!courseId) {
        this.$message.error('课程ID不存在')
        this.$router.back()
        return
      }
      
      this.loading = true
      
      try {
        const res = await courseApi.getCourseDetail(courseId)
        
        if (res && res.code === 2000) {
          this.course = res.data
          setDocumentTitle(this.course.course_name)
          setWechatShare({
            title: this.course.course_name,
            desc: this.course.description || this.course.course_intro || this.course.content,
            imgUrl: DEFAULT_SHARE_IMAGE,
            link: window.location.href.split('#')[0]
          })
        }
      } catch (error) {
        console.error('加载课程详情失败:', error)
        this.$message.error('加载课程详情失败')
      } finally {
        this.loading = false
      }
    },
    
    /**
     * 立即购买
     */
    async handleBuyNow() {
      try {
        await this.$confirm(
          '确认购买该课程吗？',
          '购买确认',
          {
            confirmButtonText: '确认购买',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        
        // 调用购买接口，传入单个课程ID的数组
        const response = await courseApi.purchaseCourses([this.course.id])
        
        if (response.code === 1) {
          this.$message.success('购买成功！')
          // 可以跳转到订单页面或刷新页面
          // this.$router.push('/user/orders')
        } else {
          this.$message.error(response.msg || '购买失败，请重试')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('购买课程失败:', error)
          this.$message.error('购买失败，请重试')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.course-detail {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
  
  .course-header {
    padding: 20px 0;
    
    .course-cover {
      height: 400px;
      border-radius: 8px;
      overflow: hidden;
      
      .el-image {
        width: 100%;
        height: 100%;
      }
      
      .image-slot {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: #f5f7fa;
        color: #909399;
        font-size: 60px;
      }
    }
    
    .course-info {
      .course-title {
        margin: 0 0 20px 0;
        font-size: 28px;
        color: #303133;
      }
      
      .course-meta {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 20px;
        
        .meta-item {
          display: flex;
          align-items: center;
          gap: 5px;
          color: #606266;
          font-size: 14px;
        }
      }
      
      .course-desc {
        margin-bottom: 20px;
        padding: 15px;
        background-color: #f5f7fa;
        border-radius: 4px;
        color: #606266;
        line-height: 1.6;
      }
      
      .course-price {
        margin-bottom: 30px;
        
        .price-label {
          font-size: 16px;
          color: #606266;
        }
        
        .price-value {
          font-size: 32px;
          font-weight: bold;
          color: #f56c6c;
          margin-left: 10px;
        }
      }
      
      .course-actions {
        display: flex;
        gap: 15px;
      }
    }
  }
  
  .course-tabs {
    margin-top: 30px;
    
    .course-intro {
      padding: 20px;
      line-height: 1.8;
      color: #606266;
      font-size: 15px;
    }
  }
}

@media (max-width: 768px) {
  .course-detail {
    padding: 10px;
    
    .course-header {
      .course-cover {
        height: 250px;
        margin-bottom: 20px;
      }
      
      .course-info {
        .course-title {
          font-size: 22px;
        }
        
        .course-actions {
          flex-direction: column;
          
          .el-button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
